import React from "react";
import { Typography, useTheme } from "@mui/material";
import { useDropzone } from "react-dropzone";

const DragAndDropUpload = ({ onDrop, fileType, multi }) => {
  const theme = useTheme();
  let accept = {};
  if (fileType === "image") {
    accept = { "image/*": [] };
  } else if (fileType === "excel") {
    accept = { ".xls": ["xls"], ".xlsx": ["xlsx"], ".csv": ["csv"] };
  } else if (fileType === "both") {
    accept = {
      "image/*": [],
      ".xls": [".xls"],
      ".xlsx": [".xlsx"],
      ".csv": [".csv"],
    };
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: accept,
    multiple: multi,
  });

  return (
    <section
      className="container"
      style={{
        cursor: "pointer",
        flex: 1,
        border: "1px dashed #474747",
        borderRadius: "4px",
      }}
    >
      <div
        {...getRootProps({ className: "dropzone" })}
        style={{
          textAlign: "center",
          padding: "12px",
          borderWidth: "2px",
          borderRadius: "3px",
          backgroundColor: isDragActive ? "#f0f0f0" : "transparent",
          transition: "background-color 0.3s ease",
        }}
      >
        <input {...getInputProps()} />
        <Typography
          variant="h6"
          gutterBottom
          style={{ color: "#696969", fontWeight: "400", fontSize: "16px" }}
        >
          Drag and drop or{" "}
          <span style={{ color: `${theme?.customSettings?.themeColor}` }}>
            choose file(s)
          </span>
        </Typography>
      </div>
    </section>
  );
};

export default DragAndDropUpload;
